const paywallStyle = Object.freeze({
  illustration: 'astronaut',
});

export default paywallStyle;
